export type AuthProvider = 'email' | 'google' | 'apple'

const LAST_PROVIDER_KEY = 'veltica_last_auth_provider'
const PENDING_PROVIDER_KEY = 'veltica_pending_auth_provider'

function isAuthProvider(value: string | null | undefined): value is AuthProvider {
  return value === 'email' || value === 'google' || value === 'apple'
}

export function getLastAuthProvider(): AuthProvider | null {
  const provider = window.localStorage.getItem(LAST_PROVIDER_KEY)
  return isAuthProvider(provider) ? provider : null
}

export function beginAuthAttempt(provider: AuthProvider) {
  window.localStorage.setItem(PENDING_PROVIDER_KEY, provider)
}

export function cancelAuthAttempt(provider: AuthProvider) {
  if (window.localStorage.getItem(PENDING_PROVIDER_KEY) === provider) {
    window.localStorage.removeItem(PENDING_PROVIDER_KEY)
  }
}

export function completeAuthAttempt(user?: {
  identities?: Array<{ provider?: string; last_sign_in_at?: string }> | null
}) {
  const pendingProvider = window.localStorage.getItem(PENDING_PROVIDER_KEY)
  let provider: AuthProvider | null = isAuthProvider(pendingProvider) ? pendingProvider : null

  if (!provider && user?.identities?.length) {
    const latestIdentity = [...user.identities].sort((a, b) => {
      const aTime = a.last_sign_in_at ? Date.parse(a.last_sign_in_at) : 0
      const bTime = b.last_sign_in_at ? Date.parse(b.last_sign_in_at) : 0
      return bTime - aTime
    })[0]
    if (isAuthProvider(latestIdentity?.provider)) provider = latestIdentity.provider
  }

  if (provider) window.localStorage.setItem(LAST_PROVIDER_KEY, provider)
  window.localStorage.removeItem(PENDING_PROVIDER_KEY)
}
